import React, {useEffect, useState} from "react";
import {getTurnDetails} from "../../../services/queue-turn";
import {useParams} from "react-router-dom";
import {CircularProgress} from "@mui/material";
import {
    connectToSocket,
    emitSocketEvent,
    onSocketEvent,
} from "../../../services/socket";
import {useAuth} from "../../../context/AuthContext";

export default function TurnDetailsPage() {
    const {turnID} = useParams();
    const [instData, setInstData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [turnData, setTurnData] = useState({});
    const {setInstLogoData, token} = useAuth();

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const res = await getTurnDetails(turnID);
                const actualTurnId = res.data.turnId;

                connectToSocket(token);
                emitSocketEvent("join-queue-turn-room", {queueTurnId: actualTurnId});
                onSocketEvent("queue:turn:status:update", (data) => {
                    setTurnData(data);
                });

                const data = {
                    institutionName: res.data.institutionName,
                    branchName: res.data.branchName,
                    serviceName: res.data.serviceName,
                };
                setInstData(data);
                setTurnData(res.data);
                setInstLogoData(res.data.institutionImage);
            } catch (err) {
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [turnID]);

    const renderStatusTag = (status) => {
        const statusMap = {
            waiting: "قيد الانتظار",
            in_service: "جاري خدمتك",
            completed: "تمت خدمتك",
        };
        const label = statusMap[status] || "غير معروف";
        return <span className={`status-tag status-${status}`}>{label}</span>;
    };

    const renderQueueMessage = (status, count) => {
        if (status === "in_service") return "🟢 دورك الآن، توجه للموظف";
        if (count === 2) return "🟢 قرب دورك، خلك جاهز";
        if (count <= 2) return "🟢 زحمة خفيفة، خلك جاهز";
        if (count <= 5) return "🟡 فيه ناس قبلك، اصبر شوي";
        if (count <= 10) return "🟠 الزحمة متوسطة، خلك متابع";
        return "🔴 الزحمة قوية، خذ لك قهوة وتعال";
    };

    const renderProgressStyle = (count) => {
        let color = "green";
        if (count >= 15) color = "red";
        else if (count >= 8) color = "orange";
        return {
            height: "100%",
            width: `${Math.min((count / 10) * 100, 100)}%`,
            background: color,
        };
    };

    return (
        <div className="page center">
            <style>{`
            
            .center{
            display: flex;
            justify-content: center;
            align-items: center;
            }
                .turn-card {
                    background: #fff;
                    border-radius: 16px;
                    border: 1px solid var(--clr-border);
                    box-shadow: 0 2px 6px rgba(0,0,0,0.03);
                    width: 100%;
                    max-width: 400px;
                    padding: 24px;
                    margin: 0 auto;
                    direction: rtl;
                    font-family: 'Tajawal', sans-serif;
                    text-align: center;
                }

                .card-header {
                    font-size: 16px;
                    font-weight: bold;
                    color: #003366;
                    margin-bottom: 20px;
                }

                .turn-number {
                    font-size: 40px;
                    font-weight: bold;
                    color: var(--clr-primary);
                    margin: 0 0 10px;
                }

                .queue-message {
                    font-size: 16px;
                    color: #444;
                    margin-bottom: 20px;
                }

                .stat-box {
                    display: flex;
                    justify-content: space-between;
                    font-size: 14px;
                    background: #fff;
                    padding: 8px 12px;
                    border-radius: 8px;
                    border: 1px solid #e1e1e1;
                    margin-bottom: 10px;
                    color: #003366;
                }

                .progress-wrap {
                    height: 6px;
                    background: #ddd;
                    border-radius: 4px;
                    overflow: hidden;
                    margin-bottom: 16px;
                }

                .info-box {
                    background: #f9f9f9;
                    border-radius: 12px;
                    padding: 12px 16px;
                    margin-bottom: 16px;
                    text-align: right;
                    font-size: 14px;
                    color: #333;
                }

                .info-box span {
                    display: block;
                    margin-bottom: 6px;
                }

                .info-box strong {
                    font-weight: bold;
                    color: #111;
                }

                .status-tag {
                    display: inline-block;
                    margin-top: 10px;
                    padding: 4px 12px;
                    border-radius: 8px;
                    font-size: 13px;
                    font-weight: 600;
                }

                .status-waiting {
                    background: #fffbe6;
                    color: #b38f00;
                }

                .status-in_service {
                    background: #e6fffb;
                    color: #007a78;
                }

                .status-completed {
                    background: #e8f5e9;
                    color: #2e7d32;
                }

                .buttons-row {
                    display: flex;
                    justify-content: space-between;
                    gap: 12px;
                    margin-top: 24px;
                }

                .btn {
                    flex: 1;
                    padding: 10px;
                    border-radius: 8px;
                    font-weight: bold;
                    cursor: pointer;
                    border: none;
                    font-size: 14px;
                }

                .btn-secondary {
                    background-color: #f0f8ff;
                    color: #035388;
                    border: 1px solid #90cdf4;
                }

                .btn-danger {
                    background-color: #fff5f5;
                    color: #cc0000;
                    border: 1px solid #f5c2c2;
                }
            `}</style>
            <div className='content-view center'>
                <div className="turn-card">
                    {isLoading ? (
                        <CircularProgress/>
                    ) : (
                        <>
                            <div className="card-header">تفاصيل دورك</div>
                            <div className="turn-number">#{turnData.customerTurn || "—"}</div>
                            <div className="queue-message">
                                {renderStatusTag(turnData.status)}
                            </div>
                            <div className="queue-message">
                                {renderQueueMessage(turnData.status, turnData.turnsLeft ?? 0)}
                            </div>

                            <div className="stat-box">
                                <span>🧍‍♂️ الانتظار: {turnData.turnsLeft ?? "—"}</span>
                                <span>⏱️ {turnData.estimatedWaitingTime ?? 0} دقيقة</span>
                            </div>

                            <div className="progress-wrap">
                                <div style={renderProgressStyle(turnData.turnsLeft ?? 0)}/>
                            </div>

                            <div className="info-box">
                                <span>🏢 المؤسسة: <strong>{instData.institutionName || "—"}</strong></span>
                                <span>📍 الفرع: <strong>{instData.branchName || "—"}</strong></span>
                                <span>🛠️ الخدمة: <strong>{instData.serviceName || "—"}</strong></span>
                            </div>

                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
